module.exports = __webpack_public_path__ + "img/msg.49d9e27f.svg";